module.exports = __webpack_public_path__ + "img/armhole length back.5a9bfc85.png";